/**
 * O cartao que leva a outra tela (menu da parametrizacao, por exemplo): o mesmo
 * acabamento do indicador e da esteira, e ao passar o mouse sobe um pouco, ganha a
 * sombra e o contorno da marca. Quem pede menos movimento no sistema nao ve a subida.
 */
export const cartaoQueAbre =
  'surface-card group transition-[box-shadow,border-color,transform] ' +
  'duration-(--duration-base) ease-(--ease-out-soft) ' +
  'hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-(--shadow-md) ' +
  'motion-reduce:hover:translate-y-0 ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500';

/** O chip do cartao que abre cresce um pouco junto com o cartao. */
export const chipDoCartaoQueAbre =
  'group-hover:scale-105 motion-reduce:group-hover:scale-100';
